import createStore from "astrid-helpers/src/createStore";
export const [getOffset, setOffset, useOffset, onOffset] = createStore(0);
//# sourceMappingURL=offset.js.map